import { defineAsyncComponent } from 'vue'
export default {
  brochure: defineAsyncComponent(() => import("/app/layouts/brochure.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m)),
  embed: defineAsyncComponent(() => import("/app/layouts/embed.vue").then(m => m.default || m)),
  mail: defineAsyncComponent(() => import("/app/layouts/mail.vue").then(m => m.default || m))
}